// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Honduras from '../_raw/flag/icon_flag_honduras.png';

export default () => <img src={Honduras} alt="Honduras" />;
